<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.teams', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <TeamsMakerTool :students="group.students" :absent="[]" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TeamsMakerTool from '@/components/pageSpecific/TeamsMakerTool.vue';

export default {
    components: {
        PanelPage,
        TeamsMakerTool,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'group'],
    data() {
        return {};
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
